import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import store from './store'

Vue.config.productionTip = false

Vue.mixin({
  methods: {
    dateTrimmer(fullDate){
      // expected fullDate YYYY-MM-DD'T'HH-MM-SS'+08:00'
      var temp = fullDate.match(/(.+?)T(.+?)\+08:00/)[1]
      return temp;
    },
    timeTrimmer(fullTime){
      // expected fullTime YYYY-MM-DD'T'HH-MM-SS'+08:00'
      var temp = fullTime.match(/(.+?)T(.+?):00\+08:00/)[2]
      return temp;
    },

    dateFormatter(date){
      // expected date YYYYMMDD
      var temp = date.match(/(\d{4})(\d{2})(\d{2})/)
      return temp;
      // return ["YYYYMMDD", "YYYY", "MM", "DD"]
    },
    vibrationHelper(e, ms){
      var temp = ms || 1 ;
      console.log(temp);

      navigator.vibrate(temp);
    }
  }
})

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
